import { render, staticRenderFns } from "./SurgeryBtns.vue?vue&type=template&id=6b16426e&"
import script from "./SurgeryBtns.vue?vue&type=script&lang=js&"
export * from "./SurgeryBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports